<template>
<span>
    <shobe-details></shobe-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import ShobeDetails from '@/components/moduls/ShobeDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'shobe',
    components:{
        ShobeDetails,
        PageFooter
    }

    
};
</script>


